import { axiosV3 } from '@/helpers/_core/axios';

export default class Application {
  static SERVICE_NAME = 'applicationV3';

  constructor({ app }) {
    this.axios = axiosV3(app);
  }

  async getApplicationSettingsByHostname(hostname) {
    return this.axios.withToken().get(`/settings/hostname/${hostname}`, {
      params: { client_id: process.env.SAFEA_CLIENT_ID }
    }).then(r => r.data);
  }
}
